import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as faqServices from "../../../services/faq.services";
import { useTranslation } from "react-i18next";

const FAQView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: t("admin.faq.link_faq"), url: "/admin/faq/list/1" },
    { title: t("admin.faq.link_view"), url: "" },
  ];

  useEffect(() => {
    faqServices
      .Details(id)
      .then((data) => {
        setShowDefault(data?.data || {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("admin.faq.heading_view")}</h6>
              </div>

              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("admin.faq.list_heading_title")}</th>
                          <td className="text-capitalize">{showdefault.title || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>Type</th>
                          <td className="text-capitalize">{showdefault.type || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("admin.faq.label_status")}</th>
                          <td>{toHtml(showStatus(showdefault.status))}</td>
                        </tr>

                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>{showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("Modified Date")}</th>
                          <td>{showdefault.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>

                    <h6 className="main-content-label mb-3">{t("admin.faq.label_description")}:</h6>

                    <div
                      className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html: showdefault.description || "N/A",
                      }}></div>

                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQView;
